/*
 * <license header>
 */

import { register } from "@adobe/uix-guest";
import { extensionId } from "./Constants";
import { sendAnalyticsData, fetchCurrentUserInfo } from '../utils';  
import { useEffect } from 'react';
import { generatePath } from 'react-router';
import { Text } from '@adobe/react-spectrum'


export default function () {
  useEffect(() => {
    let guestConnection; // Declare outside init to make it accessible in getButtons

    const init = async () => {
      // Registration object for extension methods
      const registrationConfig = {
        id: extensionId,
        methods: {
          headerMenu: {
            // Declare as `async` so you can use `await` inside
            async getButtons() {
              // Ensure guestConnection is ready
              if (!guestConnection) return [];

              const authConfig = guestConnection.sharedContext?.get('auth');
              const imsOrgId = guestConnection.sharedContext?.get('auth')?.imsOrg;
              const imsOrgName = guestConnection.sharedContext?.get('auth')?.imsOrgName;
              const aemHost = guestConnection.sharedContext?.get('aemHost');

              const currentUserId = await fetchCurrentUserInfo(aemHost, authConfig);
              
              // Store currentUserId in localStorage if present
              if (currentUserId) {
                localStorage.setItem('currentUserId', currentUserId);
              }
              
              const analyticsData = [
                {key: 'eVar14', value: imsOrgId}, 
                {key: 'eVar15', value: imsOrgName},
                {key: 'eVar4', value: aemHost}, 
                {key: 'eVar16', value: 'brand-theme'}, 
                {key: 'events', value: 'event10'}
              ];
              
              sendAnalyticsData(analyticsData, aemHost);
                    
              const contentFragment = await guestConnection.host.contentFragment.getContentFragment();
              // Change this if model path property is different
              const modelPath = contentFragment?.model?.path; 
              // console.log('[brand-theme-generator] modelPath: ', modelPath);
              const shouldShowButton = modelPath && modelPath.endsWith('/brand-theme');
              
              // Check if user is from Adobe (ends with adobe.com or adobetest.com)
              const isFromAdobeId = currentUserId && (
                currentUserId.endsWith('adobe.com') || 
                currentUserId.endsWith('adobetest.com')
              );
                            
              // Hide button if model path doesn't match OR if user is from Adobe
              if (!shouldShowButton || !isFromAdobeId) {
                return []; // No buttons if condition isn't met
              }
              return [
                {
                  id: 'brand-theme',
                  label: 'Generate Theme',
                  icon: 'Brush',
                  color:'purple',
                  variant:'accent',
                  onClick: async () => {
                    
                    // Build analytics data array, conditionally including eVar3 if currentUserId is not null
                    const analyticsData = [
                      {key: 'eVar14', value: imsOrgId}, 
                      {key: 'eVar15', value: imsOrgName},
                      {key: 'eVar4', value: aemHost}, 
                      {key: 'eVar16', value: 'brand-theme'}, 
                      {key: 'events', value: 'event7'}
                    ];
                    
                    sendAnalyticsData(analyticsData, aemHost);

                    //const aemHost = https://${guestConnection.sharedContext.get('aemHost')}
                    // console.log("[brand-theme-generator] Button 'brand-theme' has been pressed.");
                    const url = '/index.html#' + generatePath('/cf/:cfPath/aigeneration', {
                      cfPath: encodeURIComponent(contentFragment.path)
                    });
                    // console.log('[brand-theme-generator] ThemePicker: ', url);
                    guestConnection.host.modal.showUrl({
                      title: 'Extract Theme from Website',
                      url,
                      width: '900px',
                    });
                  },
                },
              ];
            },
          },
        },
      };

      // Register and get guestConnection
      guestConnection = await register(registrationConfig);
    };

    init().catch(console.error);
  }, []);
    return <Text>IFrame for integration with Host (AEM)... CF Editor</Text>;
}